import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {AlarmTypeEnum, MetricInstanceAlertEntityAdditionalInfo} from "../../models/diagnostic/PartitionAlarm";
import {AlertOPEEnum} from "./AlertOPEEnum";
import {MetricAlarmStatusEnum} from "../../models/notification/MetricAlarmStatusLite";
import {WeekCalendar} from "../../models/diagnostic/WeekCalendar";

/**
 * O Inner Class
 */
class O {
  id!: number;
}

class I {
  // Id of the alert to update; omitted = create a new alert
  id?: number;
  // Metric instance (measure) watched by the alert
  metricInstanceId!: number;
  // Alert name, used in notification texts (max 100 chars)
  name!: string;
  // A disabled alert is not evaluated
  enabled!: boolean;
  // true = notify the receivers (email, WhatsApp) when the alarm starts
  beginAlarmNotificationOn!: boolean;
  // true = notify the receivers (email, WhatsApp) when the alarm ends
  endAlarmNotificationOn!: boolean;
  // Not read by the BE: the alarm status is computed, never set by the client
  alarmStatus?: MetricAlarmStatusEnum;
  // Omitted = THRESHOLD; for STATIC the rule goes in additionalInfo.staticAlarm
  alarmType?: AlarmTypeEnum;
  // Alarm definition by data type (thresholds, boolean/string values, static rule) and notification receivers
  additionalInfo?: MetricInstanceAlertEntityAdditionalInfo;
  // true = save the three calendar fields below together with the alert, replacing the whole configuration
  // (as putWeekCalendar does), so the immediate alarm check already uses the new schedule;
  // omitted/false = calendar unchanged, the three fields are ignored
  updateCalendar?: boolean;
  // Monitoring schedule (with updateCalendar); null = remove the calendar (always monitored)
  calendar?: WeekCalendar | null;
  // true = an alarm recovering outside the schedule is closed immediately (with updateCalendar)
  calendarForcedRecovery?: boolean;
  // Re-notify when the schedule opens: null = never, 0 = every opening, N = after at least N seconds (with updateCalendar)
  alarmCooldownSec?: number | null;
}


export class PutMetricInstanceAlertCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(AlertOPEEnum.PutMetricInstanceAlert);
    this.i = new I();
    this.o = new O();
  }
}
